<page-header title="AUDIT_LOGS"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('filtered')"
  [itemsPerPage]="getPagination('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getPagination('page')"
  [sort]="getPagination('sort')"
  [orderBy]="getPagination('order_by')"
  [columns]="columns"
  [showFilter]="true"
  [showReload]="true"
  (onFilterChange)="runFilter($event)"
  [filters]="filters"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['export']"
        class="button is-link is-small"
        style="padding-left: 15px; padding-right: 15px"
      >
        <span class="icon is-small">
          <i class="fas fa-file-export"></i>
        </span>
        <span translationEditableDirective="EXPORTS">{{
          'EXPORTS' | translate
        }}</span>
      </a>
    </div>
  </ng-template>

  <ng-template let-row="row" #createdAtColumn>
    {{ row.get('createdAt') | formatDate : 'MMM DD, yyyy hh:mm:ss' }}
  </ng-template>

  <ng-template let-row="row" #objectType>
    <span
      [translationEditableDirective]="
        row.getIn(['objectType', 'translationKey'])
      "
      [translationEditableDirectiveDefault]="row.getIn(['objectType', 'title'])"
      >{{
        row.getIn(['objectType', 'translationKey'])
          | translate : { defaultValue: row.getIn(['objectType', 'title']) }
      }}</span
    >
  </ng-template>

  <ng-template let-row="row" #infoColumn>
    <button
      class="button is-ghost"
      style="
        padding: 0;
        border: 0;
        height: initial;
        outline: none !important;
        box-shadow: initial !important;
      "
      (click)="toggleInfoModal(row.get('id'))"
    >
      <span class="icon-text has-text-info">
        <span class="icon">
          <i class="fas fa-info-circle"></i>
        </span>
      </span>
    </button>
  </ng-template>
</app-table>

<div class="modal" [ngClass]="{ 'is-active': isInfoModalOpen }">
  <div class="modal-background" (click)="toggleInfoModal()"></div>
  <div class="modal-card">
    <header class="modal-card-head" style="justify-content: space-between">
      <span
        class="modal-card-title"
        style="margin: 0; padding: 0; flex-grow: 0"
        translationEditableDirective="CHANGE_DETAILS"
      >
        {{ 'CHANGE_DETAILS' | translate }}
      </span>
      <button
        class="delete"
        aria-label="close"
        (click)="toggleInfoModal()"
      ></button>
    </header>
    <section
      class="modal-card-body"
      style="border-bottom-left-radius: 6px; border-bottom-right-radius: 6px"
    >
      <span
        class="loading"
        *ngIf="isInfoLoading"
        translationEditableDirective="LOADING"
        >{{ 'LOADING' | translate }}</span
      >
      <table class="table" *ngIf="!isInfoLoading">
        <thead>
          <tr>
            <th translationEditableDirective="NAME">
              {{ 'NAME' | translate }}
            </th>
            <th translationEditableDirective="OLD_VALUE">
              {{ 'OLD_VALUE' | translate }}
            </th>
            <th translationEditableDirective="new_VALUE">
              {{ 'new_VALUE' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of info">
            <th style="font-weight: 300">
              {{ translateService.instant(row.get('key')) }}
            </th>
            <th style="font-weight: 300">{{ row.get('oldVal') }}</th>
            <th style="font-weight: 300">{{ row.get('newVal') }}</th>
          </tr>
        </tbody>
      </table>
      <span
        class="no-records"
        *ngIf="!isInfoLoading && info.size === 0"
        translationEditableDirective="NO_RECORDS"
      >
        {{ 'NO_RECORDS' | translate }}
      </span>
    </section>
  </div>
</div>
